import React, { useEffect, useRef, useState } from 'react';
import { Sparkles } from 'lucide-react';
import { useProductBrain } from '../../contexts/ProductBrainContext';
import { draftInitiative } from '../../services/ollama';
import ModelPicker from './ModelPicker';

// Problem → initiative handoff: the model drafts, the PM applies and edits.
export default function InitiativeDraft({ problem, onApply }) {
  const { data } = useProductBrain();
  const [model, setModel] = useState('');
  const [draft, setDraft] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const abort = useRef(null);
  useEffect(() => () => abort.current?.abort(), []);
  useEffect(() => { setDraft(null); setError(''); }, [problem.id]);
  const objective = draft?.okr_id && data.objectives.find(o => o.id === draft.okr_id);
  const run = async () => {
    setBusy(true); setError(''); setDraft(null); abort.current = new AbortController();
    try { setDraft((await draftInitiative({ model, problem, data, signal: abort.current.signal })).answer); }
    catch (e) { setError(e.name === 'AbortError' ? 'Request cancelled.' : e.message); }
    finally { setBusy(false); }
  };
  return <section className="v2-coach" aria-label="AI initiative draft">
    <span className="v2-label">Optional · AI draft</span>
    <p className="v2-muted">SPCC can propose the outcome, hypothesis, success metric, objective, and risks from this problem's evidence. Nothing is saved until you create the initiative.</p>
    <ModelPicker value={model} onChange={setModel}/>
    <div className="v2-actions">
      <button type="button" className="v2-button secondary" disabled={!model || busy} onClick={run}><Sparkles size={15}/>{busy ? 'Drafting…' : 'Draft with AI'}</button>
      {busy && <button type="button" className="v2-button secondary" onClick={() => abort.current?.abort()}>Cancel</button>}
    </div>
    {error && <p role="alert" className="v2-error">{error}</p>}
    {draft && <div>
      <span className="v2-label">AI interpretation · review before applying</span>
      <dl className="v2-details">
        <dt>Outcome</dt><dd>{draft.expected_outcome || '—'}</dd>
        <dt>Hypothesis</dt><dd>{draft.hypothesis || '—'}</dd>
        <dt>Metric</dt><dd>{draft.success_metric || '—'}</dd>
        <dt>Objective</dt><dd>{objective?.title || 'No clear match'}</dd>
        <dt>Risks</dt><dd>{draft.risks || '—'}</dd>
        <dt>Why</dt><dd>{draft.reason || '—'}</dd>
      </dl>
      <div className="v2-actions"><button type="button" className="v2-button" onClick={() => onApply(draft)}>Apply draft to form</button></div>
    </div>}
  </section>;
}
